let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("9adf0")]).then(() => parcelRequire('ib7sZ'));